import { useTranslation } from 'react-i18next';
import { Badge } from '@parrot-software/design-system';
import { CircleOff } from '@parrot-software/design-system/icons';

/**
 * InactiveStatusBadge - Muted badge marking a churned (INACTIVE) subscription block.
 *
 * Matches the Figma "Dada de baja" badge: muted background, muted-foreground text and a
 * circle-off icon. Takes priority over every other status badge wherever a block is
 * rendered (list card and block detail), signalling the block is read-only.
 *
 * @returns {React.ReactElement} Muted "Dada de baja" badge
 */
export const InactiveStatusBadge = () => {
  const { t } = useTranslation('subscriptions');

  return (
    <Badge className="w-fit bg-muted text-muted-foreground hover:bg-muted" variant="secondary">
      <CircleOff className="w-3 h-3 mr-1 shrink-0" />
      {t('customerState.inactive')}
    </Badge>
  );
};
